const defaultState = {};

const mutations = {
    setStandardFamilyState(state, standardFamily) {
        Object.assign(state, standardFamily);
    },
    resetStandardFamilyState(state) {
        Object.keys(state).forEach(key => {
            delete state[key];
        });
    },
};

const actions = {
    async getStandardFamilyInfo({ commit, dispatch }, standardFamilyId) {
        try {
            const { data } = await this.$rq.getStandardFamily(standardFamilyId);
            commit('setStandardFamilyState', data);
        } catch (err) {
            dispatch('resetStandardFamilyInfo');
        }
    },
    resetStandardFamilyInfo({ commit }) {
        commit('resetStandardFamilyState');
    },
};

const getters = {
    standardFamily: state => state,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
